import React from 'react'

const ResumeItem = () => {
  return (
    <div>ResumeItem</div>
  )
}

export default ResumeItem